import { render, staticRenderFns } from "./MoreNewsList.vue?vue&type=template&id=7f6d6125&scoped=true&"
import script from "./MoreNewsList.vue?vue&type=script&lang=js&"
export * from "./MoreNewsList.vue?vue&type=script&lang=js&"
import style0 from "./MoreNewsList.vue?vue&type=style&index=0&id=7f6d6125&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f6d6125",
  null
  
)

export default component.exports